module.exports = __webpack_public_path__ + "img/vg.6b4e6688.svg";